export const version1NameList = [
  {
    name: '通常',
    width: 100,
  },
  {
    name: 'IMAX',
    width: 100,
  },
  {
    name: '4DX',
    width: 100,
  },
  {
    name: 'MX4D',
    width: 100,
  },
  {
    name: 'ScreenX',
    width: 100,
  },
  {
    name: 'Dolby Cinema',
    width: 120,
  },
  {
    name: 'Dolby Atmos',
    width: 140,
  },
  {
    name: '4DX SCREEN',
    width: 140,
  },
  {
    name: 'IMAXレーザー',
    width: 140,
  },
  {
    name: 'IMAXレーザー/GT',
    width: 160,
  },
  {
    name: 'BESTIA',
    width: 100,
  },
];
export const version2NameList = [
  {
    name: '字幕',
    width: 100,
  },
  {
    name: '吹替',
    width: 100,
  },
  {
    name: 'なし',
  },
]
export const periodNameList = [
  {
    name: '午前',
    value: 'morning',
    width: 100,
  },
  {
    name: '午後',
    value: 'afternoon',
    width: 100,
  },
  {
    name: '夜',
    value: 'night',
  },
]